import { useGetSalesName } from "../sales/useGetSalesName";
import type { BCInteractionLog } from "../types";
import { RelativeDate } from "../misc/RelativeDate";
import { BCInteractionDeepLink } from "./BCInteractionDeepLink";

export const BCInteractionEntry = ({
  interaction,
}: {
  interaction: BCInteractionLog;
}) => {
  const salesName = useGetSalesName(interaction.salesperson_id, {
    enabled: !!interaction.salesperson_id,
  });

  return (
    <div className="mb-4">
      <div className="flex items-center space-x-3 w-full">
        <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold bg-slate-100 text-slate-600 border border-slate-200 shrink-0 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700">
          BC
        </span>
        <div className="text-sm text-muted-foreground truncate flex-1">
          {interaction.interaction_template_code}
          {salesName && ` · ${salesName}`}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <BCInteractionDeepLink
            interaction={interaction}
            className="text-muted-foreground hover:text-foreground"
          />
          <span className="text-sm text-muted-foreground">
            <RelativeDate date={interaction.interaction_date} />
          </span>
        </div>
      </div>
      <div className="pt-1 pl-8 text-sm">
        {interaction.description}
        {interaction.document_no && (
          <span className="ml-1 text-xs text-muted-foreground">
            ({interaction.document_type} {interaction.document_no})
          </span>
        )}
      </div>
    </div>
  );
};
